__turbopack_context__.v({
  "card": "ParagraphTextMiniCards-module__Iyt3Ca__card",
  "ctaBtn": "ParagraphTextMiniCards-module__Iyt3Ca__ctaBtn",
  "eyebrow": "ParagraphTextMiniCards-module__Iyt3Ca__eyebrow",
  "grid": "ParagraphTextMiniCards-module__Iyt3Ca__grid",
  "iconBox": "ParagraphTextMiniCards-module__Iyt3Ca__iconBox",
  "lead": "ParagraphTextMiniCards-module__Iyt3Ca__lead",
  "name": "ParagraphTextMiniCards-module__Iyt3Ca__name",
  "row": "ParagraphTextMiniCards-module__Iyt3Ca__row",
  "section": "ParagraphTextMiniCards-module__Iyt3Ca__section",
  "textCol": "ParagraphTextMiniCards-module__Iyt3Ca__textCol",
  "title": "ParagraphTextMiniCards-module__Iyt3Ca__title",
});
